import tw from 'tailwind-styled-components'

const Input = tw.input`
h-[38px]
border
border-inputBorder
text-[13.35px]
font-medium
placeholder-darkGray/70
text-darkGray
rounded-lg
pl-10
outline-gray-200
`
const SearchContainer = tw.div`
flex 
items-center 
relative 
w-full
`

export { Input, SearchContainer }
